import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage} from 'reducers/paginationArticlesSlice';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'; 
import {useTranslation} from "react-i18next"
import Box from '@mui/material/Box';    
import ArticleIcon from '@mui/icons-material/Article';  
import Checkbox from '@mui/material/Checkbox'; 
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';  
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden'; 
import "css/customDialog.css"; 

const headCellsArticleExtended = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'Text_Code',
    canOrder:true
  },
  {
    id: 'title',
    numeric: false,
    disablePadding: false,
    label: 'Text_Description',
    canOrder:true
  },
  {
    id: 'owncode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Owncode',
    canOrder:true
  },
  {
    id: 'codean',
    numeric: false,
    disablePadding: false,
    label: 'Text_Codean',
    canOrder:true
  },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Barcode',
    canOrder:true
  },
  {
    id: 'accountingcode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Accountingcode',
    canOrder:true
  },
  {
    id: 'actualstock',
    numeric: false,
    disablePadding: false,
    label: 'Text_Actualstock',
    canOrder:true
  }, 
  {
    id: 'salesunits_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Salesunitsname',
    canOrder:true
  },
  {
    id: 'applytypesofsize',
    numeric: false,
    disablePadding: false,
    label: 'Text_Applytypesofsize',
    canOrder:true
  },
  {
    id: 'applycolor',
    numeric: false,
    disablePadding: false,
    label: 'Text_Applycolor',
    canOrder:true
  },
  {
    id: 'applynumserial',
    numeric: false,
    disablePadding: false,
    label: 'Text_ApplyNumSerial',
    canOrder:true
  },
  {
    id: 'isnewpiece',
    numeric: false,
    disablePadding: false,
    label: 'Text_isNewPiece',
    canOrder:true
  },
  {
    id: 'department_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Department',
    canOrder:true
  },
  {
    id: 'section_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Section',
    canOrder:true
  },
  {
    id: 'subsection_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Group',
    canOrder:true
  } ,
  {
    id: 'codeler_code',
    numeric: false,
    disablePadding: false,
    label: 'Text_CodeLer',
    canOrder:true
  } 
];

const headCellsArticle = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'Text_Code',
    canOrder:true
  },
  {
    id: 'title',
    numeric: false,
    disablePadding: false,
    label: 'Text_Description',
    canOrder:true
  },
  {
    id: 'owncode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Owncode',
    canOrder:true
  },
  {
    id: 'codean',
    numeric: false,
    disablePadding: false,
    label: 'Text_Codean',
    canOrder:true
  },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Barcode',
    canOrder:true
  },
  {
    id: 'accountingcode',
    numeric: false,
    disablePadding: false,
    label: 'Text_Accountingcode',
    canOrder:true
  }, 
  {
    id: 'salesunits_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Salesunitsname',
    canOrder:true
  },
  {
    id: 'department_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Department',
    canOrder:true
  },
  {
    id: 'section_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Section',
    canOrder:true
  },
  {
    id: 'subsection_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Group',
    canOrder:true
  } ,
  {
    id: 'codeler_code',
    numeric: false,
    disablePadding: false,
    label: 'Text_CodeLer',
    canOrder:true
  } 
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,showEditButtonArticle,showDeleteButtonArticle,showExtendedFilter } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {showEditButtonArticle&&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        <TableCell
            key='contactdetails'
            align='center'
            padding='normal'
            sortDirection={false}
          >
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {t('Text_View_Data')}
          </Typography>
        </TableCell>
        {showExtendedFilter ?
          headCellsArticleExtended.map((headCell, indexhead) => (
            <TableCell
              key={indexhead}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.canOrder ?(
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t(headCell.label)}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel>):
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t(headCell.label)}
                </Typography>}
            </TableCell>
          )):
           headCellsArticle.map((headCell, indexhead) => (
            <TableCell
              key={indexhead}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.canOrder ?(
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t(headCell.label)}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel>):
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t(headCell.label)}
                </Typography>}
            </TableCell>
          ))
        }
       
         {showDeleteButtonArticle&&
        <TableCell
          key='delete'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#e74a3b", fontSize: 16}} > 
            {t('Button_Delete')}
          </Typography>
        </TableCell>}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegArticle, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegArticle).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataArticles']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingArticle =(props)=>{
  const { 
    dataArticle,
    numTotRegFilter,
    titleTable,
    setOpenDeleteRowArticle,
    setRowEditArticle,
    showEditButtonArticle,
    showDeleteButtonArticle, 
    numTotRegArticle,
    activeOffsetArticle,
    rangeOffsetArticle,
    currencyOffsetArticle,
    setCurrencyOffsetArticle,
    setOpenViewDetails,
    minvalue,
    showExtendedFilter
  } = props;
  const {t,i18n} = useTranslation(['listDataArticles']);
  const dispatch = useDispatch();
  const { currentPage, order, orderBy,rowsPerPage } = useSelector((state) => state.paginationArticles);
  const [countData,setCountData] = useState(dataArticle.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataArticle.length) : 0);
  
  useEffect(
    () => {
      setCountData(dataArticle.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataArticle.length) : 0);  
    },
    [dataArticle,page,setEmptyRows,rowsPerPage,countData]
  );

  const handleChangeOffset = (event) => {
    setCurrencyOffsetArticle(event.target.value);
  };
 
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
    dispatch(setOrderBy(property)); // Actualiza Redux
  };  
 
  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };

  const openModalDeleteRowDepartment = (row) => {
    setRowEditArticle(row);
    setOpenDeleteRowArticle(true);
  };

  const openModalViewDetails = (row) => {
    setRowEditArticle(row);
    setOpenViewDetails(true);
  };

  const listItems = stableSort(dataArticle, getComparator(order, orderBy))
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonArticle && row.id!=="" && row.id!==null ) &&
        <TableCell align="center">
          <Link  to={`/articledetail/${row.id}`} >
            <IconButton size="large" className="edit-icon-button" sx={{background:(row.codehex!==undefined && row.codehex!=="")&&row.codehex+" !important"}} >
             <EditIcon style={{fontSize: 28}}/>
            </IconButton>
          </Link>
        </TableCell>} 
        <TableCell align="center">
           <IconButton size="large" className="sheet-icon-button" 
              sx={
                {color:(row.codehex!==undefined && row.codehex!=="")&&row.codehex+" !important",
                  borderColor:(row.codehex!==undefined && row.codehex!=="")&&row.codehex+" !important"
                }} 
              onClick={()=>openModalViewDetails(row)}>
            <ArticleIcon style={{fontSize: 28}}/>
          </IconButton>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.id}
          </Typography>  
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {i18n.language==="es"?row.titlees:row.titleen}
          </Typography>  
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.owncode}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.codean}
          </Typography>
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.barcode}
          </Typography>
        </TableCell> 
         <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.accountingcode}
          </Typography>
        </TableCell> 
        {showExtendedFilter && 
          <TableCell align="right">
            <Typography style={{color:"#000000", fontSize: 16}} >  
              {row.actualstock}
            </Typography>
          </TableCell> 
        } 
        <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
           {i18n.language==="es"?row.salesunits_namees:row.salesunits_nameen}
          </Typography>
        </TableCell> 
        {showExtendedFilter && 
          <>
            <TableCell align="center">
              <Checkbox checked={row.applytypesofsize} disabled
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                }}
              />
            </TableCell> 
            <TableCell align="center">
              <Checkbox checked={row.applycolor} disabled
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                }}
              />
            </TableCell> 
            <TableCell align="center">
              <Checkbox checked={row.applynumserial} disabled
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                }}
              />
            </TableCell> 
            <TableCell align="center">
              <Checkbox checked={row.applynumserial} disabled
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                }}
              />
            </TableCell> 
          </>
        }  
         <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {i18n.language==="es"?row.department_namees:row.department_nameen}
          </Typography>
        </TableCell> 
         <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {i18n.language==="es"?row.section_namees:row.section_nameen}
          </Typography>
        </TableCell> 
         <TableCell align="left">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {i18n.language==="es"?row.subsection_namees:row.subsection_nameen}
          </Typography>
        </TableCell> 
        <TableCell align="right">
          <Typography style={{color:row.codehex?row.codehex:"#000000", fontSize: 16}} >  
            {row.codeler_code}
          </Typography>
        </TableCell> 
        {(showDeleteButtonArticle && row.id!=="" && row.id!==null) &&
        <TableCell align="center">
          <IconButton size="large" className={row.id>minvalue?"delete-icon-button":"delete-noicon-button"} onClick={row.id>minvalue?()=>openModalDeleteRowDepartment(row):() => {}}>
            <DeleteIcon style={{fontSize: 28}}/>
          </IconButton>
        </TableCell>}
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegArticle={numTotRegArticle} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '750px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
             <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t} showEditButtonArticle={showEditButtonArticle} showDeleteButtonArticle={showDeleteButtonArticle} showExtendedFilter={showExtendedFilter}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={19} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetArticle && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetArticle"
                            name="currencyOffsetArticle"
                            value={currencyOffsetArticle}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetArticle
                            }}>
                            {rangeOffsetArticle.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={19}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingArticle.propTypes = {
  dataArticle: PropTypes.array.isRequired,
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,
  setOpenDeleteRowArticle: PropTypes.func.isRequired,
  setRowEditArticle: PropTypes.func.isRequired,    
  showEditButtonArticle: PropTypes.bool.isRequired,  
  showDeleteButtonArticle: PropTypes.bool.isRequired,
  numTotRegArticle: PropTypes.number.isRequired,
  activeOffsetArticle: PropTypes.bool.isRequired,
  rangeOffsetArticle: PropTypes.array.isRequired,
  currencyOffsetArticle: PropTypes.number.isRequired,
  setCurrencyOffsetArticle: PropTypes.func.isRequired,
  setOpenViewDetails: PropTypes.func.isRequired,
  minvalue: PropTypes.number.isRequired
};
  
export default TableSortingArticle;